<template>
  <v-row>
    <v-col cols="12" align-self="center">
      <v-tabs v-model="tab" grow show-arrows>
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="title in tabTitle" :key="title">
          {{ $t(title) }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-for="(title, index) in tabTitle" :key="title">
          <v-row class="ma-3">
            <v-col xl="5" lg="5" md="5" sm="12" cols="12">
              <v-text-field
                :label="$t('general.title')"
                @change="updateTitle($event, type[index])"
                :value="temp_title[type[index]]"
              ></v-text-field>
            </v-col>
            <v-col xl="5" lg="5" md="5" sm="9" cols="12">
              <v-file-input
                accept="image/*"
                :placeholder="$t('general.select_image')"
                :prepend-icon="camera_icon"
                :label="$t('general.image')"
                @change="uploadImage($event, type[index])"
              ></v-file-input>
            </v-col>
            <v-col xl="2" lg="2" md="2" sm="3" cols="12" class="d-flex align-center justify-center">
              <v-btn
                color="accent"
                depressed
                :disabled="disable_preview[type[index]]"
                :href="preview_image[type[index]]"
                target="_blank"
              >
                {{ $t('general.preview') }}
              </v-btn>
            </v-col>
          </v-row>
          <!-- <v-row class="mr-3 ml-3">
            <v-col>
              <h4>{{ $t('general.image') }}</h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12">
              <v-img max-height="400" :src="temp_image[type[index]]"></v-img>
            </v-col>
          </v-row> -->

          <v-row class="mr-3 ml-3">
            <v-col>
              <h4>{{ $t('general.content') }}</h4>
            </v-col>
          </v-row>
          <v-row class="d-flex align-center ms-3 mb-3">
            <v-col>
              <QuillEditor v-if="index == 0" editorID="editor1" :html.sync="temp_content_zh"></QuillEditor>
              <QuillEditor v-else-if="index == 1" editorID="editor2" :html.sync="temp_content_en"></QuillEditor>
              <QuillEditor v-else-if="index == 2" editorID="editor3" :html.sync="temp_content_cn"></QuillEditor>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { postData } from '@/api'
import { mdiCamera } from '@mdi/js'
import { globalFunc } from '@/global'
import QuillEditor from '@/components/QuillEditor'
import { MEDIA_PATH, DEFAULT_IMAGE_PATH } from '@/global'

export default {
  name: 'MediaCoverageTab',
  mixins: [globalFunc, MEDIA_PATH, DEFAULT_IMAGE_PATH],
  components: { QuillEditor },
  props: ['content', 'title', 'image'],
  data: () => ({
    camera_icon: mdiCamera,
    tab: null,
    type: ['zh', 'en', 'cn'],
    tabTitle: ['general.zh', 'general.en', 'general.cn'],
    temp_title: {
      zh: '',
      en: '',
      cn: '',
    },
    // temp_image: {
    //   zh: '',
    //   en: '',
    //   cn: '',
    // },
    preview_image: {
      zh: '',
      en: '',
      cn: '',
    },
    disable_preview: {
      zh: true,
      en: true,
      cn: true,
    },
    temp_content_zh: '',
    temp_content_en: '',
    temp_content_cn: '',
  }),
  methods: {
    async uploadImage(files, type) {
      try {
        if (files == null) {
          this.preview_image[type] = ''
          this.disable_preview[type] = true
          this.$emit('getImage', '', type)
          return
        }

        let params = new URLSearchParams()
        let base64Path = await globalFunc.firstFileToBase64(files)
        let fileType = files.name.substring(files.name.lastIndexOf('.') + 1)
        params.set(
          'upload_file',
          JSON.stringify({
            upload_data: base64Path,
            upload_file_type: fileType,
          }),
        )

        let upload_file = await postData(params)

        this.preview_image[type] = MEDIA_PATH + upload_file
        this.disable_preview[type] = false
        this.$emit('getImage', upload_file, type)
      } catch (error) {
        globalFunc.log(error)
      }
    },
    updateTitle(event, type) {
      this.$emit('getTitle', event, type)
    },
  },
  watch: {
    temp_content_zh: function (newVal, oldVal) {
      this.$emit('getContent', newVal, 'zh')
    },
    temp_content_en: function (newVal, oldVal) {
      this.$emit('getContent', newVal, 'en')
    },
    temp_content_cn: function (newVal, oldVal) {
      this.$emit('getContent', newVal, 'cn')
    },
    title: function (newVal, oldVal) {
      this.temp_title.zh = newVal.zh
      this.temp_title.en = newVal.en
      this.temp_title.cn = newVal.cn
    },
    content: function (newVal, oldVal) {
      this.temp_content_zh = newVal.zh
      this.temp_content_en = newVal.en
      this.temp_content_cn = newVal.cn
    },
    image: function (newVal, oldVal) {
      for (let i = 0; i < this.type.length; i++) {
        if (globalFunc.DataValid(newVal[this.type[i]])) {
          this.preview_image[this.type[i]] = MEDIA_PATH + newVal[this.type[i]]
          this.disable_preview[this.type[i]] = false
        }
      }
    },
  },
}
</script>
